import { createSlice } from '@reduxjs/toolkit';
import { SuggestionsState } from '../interfaces/suggestion.interface';

/*----- CREATE STORE ------*/
declare interface SuggestionsSlice {
  name: string;
  initialState: SuggestionsState;
  reducers: any;
}

const slice: SuggestionsSlice = {
  name: 'suggestions',
  initialState: {
    suggestions: {}
  },
  reducers: {
    onSuccess: (state: SuggestionsState, action: any) => {
      state.suggestions[action.payload.id] = {
        data: action.payload.suggestions,
        isLoaded: true,
        isLoading: false,
        isSuccess: true,
        isFailure: false,
        message: `Successfully loaded suggestions`
      }
    },
    onFailure: (state: SuggestionsState, action: any) => {
      state.suggestions[action.payload] = {
        data: undefined,
        isLoaded: false,
        isLoading: false,
        isSuccess: false,
        isFailure: true,
        message: `Failed to load suggestions`
      }
    },
    setLoading: (state: SuggestionsState, action: any) => {
      state.suggestions[action.payload] = {
        data: state?.suggestions[action.payload]?.data,
        isLoaded: state?.suggestions[action.payload]?.isLoaded,
        isLoading: true,
        isSuccess: state?.suggestions[action.payload]?.isSuccess,
        isFailure: state?.suggestions[action.payload]?.isFailure,
        message: `Loading suggestions`
      }
    },
    clearSuggestions: (state: SuggestionsState) => {
      state.suggestions = {};
    },
  },
};

export const suggestionsSlice: any = createSlice(slice);

/*----- EXPORT ACTIONS ------*/
export const onSuccess: Function = suggestionsSlice.actions.onSuccess;
export const onFailure: Function = suggestionsSlice.actions.onFailure;
export const setLoading: Function = suggestionsSlice.actions.setLoading;
export const clearSuggestions: Function = suggestionsSlice.actions.clearSuggestions;


/*----- EXPORT DEFAULT ------*/
export const suggestionsReducer = suggestionsSlice.reducer;
